module.exports = __webpack_public_path__ + "static/WEDDING E&M-174-3e31405a899dcdd12d60fda1ac450f1d.jpg";